export const APP_STORE_URL = 'https://apps.apple.com/us/app/a-l-e-ask-listen-explore/id6760979027';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.ale.tours';
